export default "__VITE_ASSET__6761f3b8__"